var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Model from 'models/Model';
import { DocumentLineEntityType, TransactionType } from 'models';
import { plainToInstance } from 'class-transformer';
var DocumentLineMetaInfo = /** @class */ (function (_super) {
    __extends(DocumentLineMetaInfo, _super);
    function DocumentLineMetaInfo() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DocumentLineMetaInfo.prototype.getTransactionEntryTypes = function () {
        return plainToInstance(TransactionType, this.transaction_entry_types);
    };
    DocumentLineMetaInfo.prototype.getEntityTypes = function () {
        return plainToInstance(DocumentLineEntityType, this.entity_types);
    };
    return DocumentLineMetaInfo;
}(Model));
export default DocumentLineMetaInfo;
